export const environment = {
    production: false,
    API_HOME: 'http://global-agency.wtesta.com/'
};
